import { useParams } from "react-router-dom";
import { T } from "@/components/editable/T";

const PAGE = "home";

export const VIDEO_SRC_BY_LANG: Record<string, string> = {
  nl: "https://player.vimeo.com/video/1226576493?h=62816f08cd&badge=0&autopause=0&player_id=0&app_id=58479",
  en: "https://player.vimeo.com/video/1226596620?h=e076274705&badge=0&autopause=0&player_id=0&app_id=58479",
  de: "https://player.vimeo.com/video/1226611245?h=0d0167d78c&badge=0&autopause=0&player_id=0&app_id=58479",
};

export const BrandVideo = () => {
  const { lang } = useParams<{ lang: string }>();
  const videoSrc = VIDEO_SRC_BY_LANG[lang ?? "nl"] ?? VIDEO_SRC_BY_LANG.nl;

  return (
    <section className="px-4 py-20 sm:px-6 bg-background">
      <div className="mx-auto w-full max-w-5xl">
        <div className="text-center mb-10">
          <h2 className="feature-section-heading text-foreground mb-4">
            <T
              page={PAGE}
              k="brandVideo.title"
              d="Alles wat je nodig hebt voor high-performing teams"
            />
          </h2>
        </div>

        <div className="relative overflow-hidden rounded-3xl shadow-lg" style={{ paddingTop: "56.25%" }}>
          <iframe
            src={videoSrc}
            title="Learned Framework | Work Design, Performance Management & Compensation"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            loading="lazy"
            className="absolute inset-0 h-full w-full border-0"
          />
        </div>
      </div>
    </section>
  );
};
